export default __webpack_public_path__ + "static/media/down-arrow.15b3b5dc.svg";